import React from "react";
import { AuditLog, AuditLogChangeType } from "@common/types/auditLog";
import {
    ChatChangeComponent,
    defineChatChangeComponent,
} from "../helpers/defineChatChangeComponent";
import { ChatTaskStatus } from "./ChatTaskStatus";
import { ChatTaskAssignee } from "./ChatTaskAssignee";
import { ChatTaskDueDate } from "./ChatTaskDueDate";
import { ChatTaskPriority } from "./ChatTaskPriority";
import { ChatTaskEstimatedTime } from "./ChatTaskEstimatedTime";
import { ChatTaskEntities } from "./ChatTaskEntities";
import { ChatTaskTitle } from "./ChatTaskTitle";
import { ChatTaskFinancialDocuments } from "./ChatTaskFinancialDocuments";
import { ChatTaskBlockedBy } from "./ChatTaskBlockedBy";
import { ChatTaskBlocking } from "./ChatTaskBlocking";
import { ChatTaskRelated } from "./ChatTaskRelated";
import { ChatTaskCloseField } from "./ChatTaskClose";

export function getChatTaskAuditLogContent(
    log: AuditLog,
): React.ReactNode | null {
    if (log.changeType === AuditLogChangeType.CREATE) {
        return "created this task";
    }

    const changeComponent = defineChatChangeComponent(log);

    switch (changeComponent) {
        case ChatChangeComponent.TITLE:
            return <ChatTaskTitle log={log} />;
        case ChatChangeComponent.STATUS:
            return <ChatTaskStatus log={log} />;
        case ChatChangeComponent.ASSIGNEE:
            return <ChatTaskAssignee log={log} />;
        case ChatChangeComponent.DUE_DATE:
            return <ChatTaskDueDate log={log} />;
        case ChatChangeComponent.PRIORITY:
            return <ChatTaskPriority log={log} />;
        case ChatChangeComponent.ESTIMATED_TIME:
            return <ChatTaskEstimatedTime log={log} />;
        case ChatChangeComponent.ENTITIES:
            return <ChatTaskEntities log={log} />;
        case ChatChangeComponent.FINANCIAL_DOCUMENTS:
            return <ChatTaskFinancialDocuments log={log} />;
        case ChatChangeComponent.BLOCKED_BY_TASKS:
            return <ChatTaskBlockedBy log={log} />;
        case ChatChangeComponent.BLOCKING_TASKS:
            return <ChatTaskBlocking log={log} />;
        case ChatChangeComponent.RELATED_TASKS:
            return <ChatTaskRelated log={log} />;
        case ChatChangeComponent.CLOSE_STAGE:
            return (
                <ChatTaskCloseField
                    log={log}
                    field="closeStageId"
                    label="stage"
                />
            );
        case ChatChangeComponent.CLOSE:
            return (
                <ChatTaskCloseField log={log} field="closeId" label="service" />
            );
        default:
            return null;
    }
}
